export const MAIN_CLASS = 'OfferGallery';
export const MAX_VISIBLE_ITEMS_NUMBER = 5;
